import { validateLabelValueFormat } from '../../LabelPanel.utils';

import {
	LABEL_VALUES_CSV_ERROR_REPORT_FILENAME,
	LABEL_VALUES_LABELS
} from './LabelValuesSection.labels';

const escapeCsvField = (value: string): string => {
	if (/[",\n\r]/.test(value)) {
		return `"${value.replace(/"/g, '""')}"`;
	}
	return value;
};

/**
 * Builds a two-column CSV (Value, Status) for values from a rejected upload file,
 * marking each row Invalid or OK per {@link validateLabelValueFormat}.
 */
const buildLabelValuesCsvErrorReport = (orderedValues: string[]): string => {
	const header = `${escapeCsvField(LABEL_VALUES_LABELS.CSV_ERROR_REPORT_VALUE_COLUMN)},${escapeCsvField(
		LABEL_VALUES_LABELS.CSV_ERROR_REPORT_STATUS_COLUMN
	)}`;
	const rows = orderedValues.map((v) => {
		const formatError = validateLabelValueFormat(v);
		const status = formatError
			? LABEL_VALUES_LABELS.CSV_ERROR_REPORT_STATUS_INVALID
			: LABEL_VALUES_LABELS.CSV_ERROR_REPORT_STATUS_OK;
		return `${escapeCsvField(v)},${escapeCsvField(status)}`;
	});
	return [header, ...rows].join('\n');
};

export const downloadLabelValuesCsvErrorReport = (orderedValues: string[]): void => {
	const csv = buildLabelValuesCsvErrorReport(orderedValues);
	const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
	const url = URL.createObjectURL(blob);
	const anchor = document.createElement('a');
	anchor.href = url;
	anchor.download = LABEL_VALUES_CSV_ERROR_REPORT_FILENAME;
	anchor.click();
	URL.revokeObjectURL(url);
};
